import React from 'react';
import styles from './YouTubeEmbed.module.scss';

function getSrc(link: string): string | undefined {
  if (!link.includes('youtu.be') && !link.includes('youtube')) {
    return;
  }

  let url = 'https://www.youtube.com/embed/';
  let id = '';
  let start = '';

  // It's a playlist
  if (link.includes('playlist?list=')) {
    url += 'videoseries?list=';
    id = link.split('playlist?list=')[1];
  } else if (link.includes('youtu.be')) {
    id = link.split('youtu.be/')[1];
  } else if (link.includes('watch?v=')) {
    id = link.split('watch?v=')[1];
  }

  if (id.includes('&t=')) {
    start = `?start=${id.split('&t=')[1]}`;
    id = id.split('&t=')[0];
  }

  return `${url}${id}${start}`;
}

export interface YouTubeEmbedProps {
  link: string;
}

export const YouTubeEmbed = ({
  link
}: YouTubeEmbedProps): React.ReactElement<YouTubeEmbedProps> => {
  const src = getSrc(link);

  return (
    <>
      {src && (
        <div className={styles.youTubeEmbed}>
          <iframe
            src={src}
            frameBorder="0"
            allowFullScreen
            title="Embedded youtube"
          />
        </div>
      )}
    </>
  );
};
